var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostureStanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0635 5.9835C13.3016 5.9835 14.3053 4.97983 14.3053 3.74175C14.3053 2.50367 13.3016 1.5 12.0635 1.5C10.8254 1.5 9.82178 2.50367 9.82178 3.74175C9.82178 4.97983 10.8254 5.9835 12.0635 5.9835Z",
    fill: "#0D212C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87693 6.75H4.73951C4.28767 6.75 3.92139 7.11628 3.92139 7.56812C3.92139 7.9631 4.20359 8.30169 4.5921 8.37286L10.5444 9.56943",
    fill: "#0D212C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9836 19.2293L17.8423 16.7629L17.1161 15.9354C16.567 15.3097 16.1895 14.5524 16.0204 13.7373L15.1407 9.49571L20.0792 8.37286C20.4677 8.30168 20.7499 7.96312 20.7499 7.56812C20.7499 7.1163 20.3836 6.75 19.9318 6.75H14.5712H13.5063H9.57129L11.2652 12.3966C11.7941 14.1595 12.7563 15.7619 14.0639 17.0573L14.3109 17.302C15.486 18.4661 16.7875 19.4952 18.1912 20.3702L19.5776 21.2344C20.0618 21.5362 20.69 21.4643 21.0934 21.0609C21.6134 20.5409 21.562 19.6834 20.9836 19.2293Z",
    fill: "#0D212C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.0714 12.582L8.94479 14.2321C8.07127 14.6931 7.41257 15.4773 7.10934 16.4173L5.99533 19.8707C5.78761 20.5146 6.10711 21.2104 6.73085 21.4725C7.43047 21.7665 8.23232 21.403 8.4723 20.683L9.80952 16.6714L14.8165 15.5207L12.0714 12.582Z",
    fill: "#0D212C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostureStanding);
export default __webpack_public_path__ + "static/media/PostureStanding.db52315dec3351099d3e4013f642cac5.svg";
export { ForwardRef as ReactComponent };